import { Container, Stack, useMediaQuery, useTheme } from "@mui/material";
import { Text } from "./Text";

export const CompanyDetail = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const members = [
    {
      name: "CEO　林修",
      text: "東工大修士課程修了。大手化学メーカーにて製品開発に従事し、新規事業開発において豊富な経験を持つ。CVCにおけるスタートアップ投資、伴走支援経験あり。また、新規事業開発コンサルタントとしての経験も豊富。",
      image: "/images/hayashi.png",
      color: "#006400",
    },
    {
      name: "CTO　鎌倉高志 ",
      text: "農学博士。長年にわたり植物病原真菌の感染メカニズムや遺伝子機能解析の研究に従事してきた。\n真菌類の研究者として名高い、微生物に恋した科学者。現在、東京理科大学 創域理工学部 教授。",
      image: "/images/kamakura.png",
      color: "#7e0000",
    },
    {
      name: "CSO　荒添貴之 ",
      text: "農学博士。学生時代より微生物の進化に興味を持つ。様々な生物種でのゲノム編集経験を有し、鎌倉教授の下で難解な真菌ゲノム編集を推進。現在、東京理科大学 創域理工学部 講師。",
      image: "/images/arazoe.png",
      color: "#002d64",
    },
  ];

  return (
    <Container>
      <Stack
        direction="row"
        gap={isMobile ? 2 : 3.5}
        justifyContent="center"
        alignItems="center"
        sx={{
          "&:before,&:after": {
            content: "''",
            display: "block",
            width: "50%",
            maxWidth: isMobile ? 100 : 390,
            height: 2,
            background: "#bdbdbd",
          },
        }}
      >
        <Text variant="h2" color="#bdbdbd">
          Company
        </Text>
      </Stack>
      <Stack marginTop={isMobile ? 2 : 3.6} padding={isMobile ? 0 : "0 50px"}>
        <Stack direction="row">
          <Text width={isMobile ? 100 : 180} minWidth={isMobile ? 100 : 180}>
            社 名：
          </Text>
          <Text>株式会社 MycoGenome</Text>
        </Stack>
        <Stack direction="row" marginTop={2}>
          <Text width={isMobile ? 100 : 180} minWidth={isMobile ? 100 : 180}>
            設 立：
          </Text>
          <Text>2024年12月</Text>
        </Stack>
        <Stack direction="row" marginTop={2}>
          <Text width={isMobile ? 100 : 180} minWidth={isMobile ? 100 : 180}>
            本社所在地：
          </Text>
          <Text>東京都千代田区</Text>
        </Stack>
        <Stack direction="row" marginTop={2}>
          <Text width={isMobile ? 100 : 180} minWidth={isMobile ? 100 : 180}>
            代 表：
          </Text>
          <Text>代表取締役社長　林 修</Text>
        </Stack>
        <Stack direction="row" marginTop={2}>
          <Text width={isMobile ? 100 : 180} minWidth={isMobile ? 100 : 180}>
            事業内容：
          </Text>
          <Text>
            微生物（真菌）のゲノム編集技術の研究・開発・サービスの提供
            <br />
            ゲノム編集ツールの販売・ライセンス提供
            <br />
            ゲノム編集微生物の製造販売
          </Text>
        </Stack>
      </Stack>
      <Text
        variant="h3"
        textAlign="center"
        lineHeight={2}
        marginTop={isMobile ? 2 : 5}
        letterSpacing={50}
      >
        私たちは、微生物ゲノム編集の
        {isMobile ? <br /> : null}
        <Text
          position="relative"
          variant="overline"
          fontSize={isMobile ? 20 : 38.4}
          fontFamily='"A1", Arial, sans-serif'
          lineHeight={1}
          color="primary"
          fontWeight="bold"
          sx={{
            "&::before": {
              content: "''",
              position: "absolute",
              bottom: -4,
              left: "50%",
              display: "block",
              width: "100%",
              height: isMobile ? 6 : 10,
              background: "#ffbd00",
              zIndex: -1,
              transform: "translateX(-50%)",
            },
          }}
        >
          新しい可能性
        </Text>
        を切り拓き、
        <br />
        <Text
          position="relative"
          variant="overline"
          fontSize={isMobile ? 20 : 38.4}
          fontFamily='"A1", Arial, sans-serif'
          lineHeight={1}
          color="primary"
          fontWeight="bold"
          sx={{
            "&::before": {
              content: "''",
              position: "absolute",
              bottom: -4,
              left: "50%",
              display: "block",
              width: "100%",
              height: isMobile ? 6 : 10,
              background: "#ffbd00",
              zIndex: -1,
              transform: "translateX(-50%)",
            },
          }}
        >
          産業と社会の発展
        </Text>
        に貢献します。
      </Text>
      <Stack
        direction="row"
        flexWrap="wrap"
        justifyContent="center"
        gap={isMobile ? 2 : "35px 70px"}
        padding={isMobile ? 0 : "0 50px"}
        marginTop={isMobile ? 2 : 5}
      >
        {members.map((member, index) => {
          return (
            <Stack key={index} width="100%" maxWidth={isMobile ? 374 : 300}>
              <Stack width="100%" maxWidth="50vw" margin="0 auto">
                <img src={member.image} alt={member.name} />
              </Stack>
              <Text
                variant="h4"
                color={member.color}
                textAlign="center"
                fontWeight="bold"
                marginTop={isMobile ? 1 : 2}
              >
                {member.name}
              </Text>
              <Text
                marginTop={isMobile ? 1 : 2}
                lineHeight={1.5}
                whiteSpace="pre-wrap"
              >
                {member.text}
              </Text>
            </Stack>
          );
        })}
      </Stack>
      <Stack padding={isMobile ? 0 : "0 50px"} marginTop={isMobile ? 2 : 5}>
        <Stack border="2px solid #555" padding={isMobile ? 2 : 4.4}>
          <Stack
            direction={isMobile ? "column" : "row"}
            justifyContent="center"
            alignItems="center"
            gap={1}
          >
            <Stack
              sx={{ background: "#7e0000" }}
              alignItems="center"
              justifyContent="center"
              borderRadius={32}
              width={isMobile ? 200 : 270}
              height={isMobile ? 48 : 64}
            >
              <Text variant="h3" color="#fff">
                微生物
              </Text>
            </Stack>
            <Text fontSize={40} fontWeight="bold" color="#555555">
              ×
            </Text>
            <Stack
              sx={{ background: "#002d64" }}
              alignItems="center"
              justifyContent="center"
              borderRadius={32}
              width={isMobile ? 200 : 270}
              height={isMobile ? 48 : 64}
            >
              <Text variant="h3" color="#fff">
                ゲノム編集
              </Text>
            </Stack>
            <Text fontSize={40} fontWeight="bold" color="#555555">
              ×
            </Text>
            <Stack
              sx={{ background: "#006400" }}
              alignItems="center"
              justifyContent="center"
              borderRadius={32}
              width={isMobile ? 200 : 270}
              height={isMobile ? 48 : 64}
            >
              <Text variant="h3" color="#fff">
                社会実装
              </Text>
            </Stack>
          </Stack>
          <Text variant="h3" textAlign="center" color="#555555" marginTop={1.8}>
            新たな市場への挑戦と持続可能な技術革新を強力に推進
          </Text>
        </Stack>
      </Stack>
    </Container>
  );
};
